// Renders the active tab's Pane, or <ComingSoon> when that tab has no
// registered TabDef yet (plan §2.2 / §2.5). The active tab is the single source
// of truth `useTabStore.activeTab`.

import { useTabStore } from '@/ui/stores/use-tab-store'
import { getTab } from './tab-registry'
import { ComingSoon } from './ComingSoon'

export function ActivePane(): JSX.Element {
  const activeTab = useTabStore((s) => s.activeTab)
  const def = getTab(activeTab)
  if (!def) {
    return <ComingSoon tab={activeTab} />
  }
  const Pane = def.Pane
  return <Pane />
}
